"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntriesList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var Typography_1 = require("../../atoms/Typography/Typography");
var EntriesList_static_1 = require("./EntriesList.static");
var EntriesList_style_1 = __importDefault(require("./EntriesList.style"));
/**
 * EntriesList molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-entrieslist--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/EntriesList Source}
 */
var EntriesList = function (_a) {
    var title = _a.title, _b = _a.noItemsText, noItemsText = _b === void 0 ? EntriesList_static_1.localText.none : _b, className = _a.className, renderItems = _a.renderItems, _c = _a.noMargin, noMargin = _c === void 0 ? false : _c;
    var classes = (0, EntriesList_style_1.default)({ noMargin: noMargin });
    var items = typeof renderItems === 'function' ? renderItems() : renderItems;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [!!title && ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline2', className: classes.headline }, { children: title }))), items ? ((0, jsx_runtime_1.jsx)(core_1.List, __assign({ className: classes.entriesList }, { children: items }))) : ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.noEntries }, { children: noItemsText })))] })));
};
exports.EntriesList = EntriesList;
